import React, { useState, useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';
import { availableLanguages } from '../Core/Config';
import { isLanguageUnlocked } from '../Core/Auth';
import { fetchGroups } from '../Core/FetchData';

const SwitchLanguage = ({ onChange, activeLang, auth }) => {
    const navigate = useNavigate(); 

    const [languages, setLanguages] = useState([]); 

    const changeLanguage = (lang) => {
        if (!isLanguageUnlocked(lang, auth)) {
            return;
        }

        onChange(lang); 
        navigate('/quiz/select-group');
    };

    // nacteni dostupnych jazyku z API nebo configu
    useEffect(() => {
        const loadLanguages = async () => {     
            setLanguages(availableLanguages); 
        };
        loadLanguages();
    }, []);

    // These small public lists are ready by the time a language is selected.
    useEffect(() => {
        availableLanguages.filter(lang => isLanguageUnlocked(lang, auth)).forEach(lang => {
            void fetchGroups(lang).catch(() => {});
        });
    }, [auth]);


    return (
        <div id="quiz-switchLanguage">
            {languages && languages.length > 0 && languages.map((lang) => (

                <button key={`lang-${lang.code}`}
                        onClick={() => { changeLanguage(lang); }}
                        disabled={!isLanguageUnlocked(lang, auth)}
                        title={isLanguageUnlocked(lang, auth) ? lang.name : 'Jazyk je uzamcen pro vas tarif'}
                        className={`flag-${lang.code} {/*'initLang' === lang.code ? 'active' : 'border-primary'*/}`} >

                    <span>
                        {lang.code === 'cs' ? (
                            <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="180" height="120" className="bg-[#ff0000]"><rect width="180" height="60" fill="#fff" /><path d="M 90,60 0,0 V 120 z" fill="#11457e" /></svg>
                        ) : lang.code === 'en' ? (
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" width="180" height="120"><clipPath id="s"><path d="M0,0 v30 h60 v-30 z" /></clipPath><clipPath id="t"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" /></clipPath><g clipPath="url(#s)"><path d="M0,0 v30 h60 v-30 z" fill="#012169" /><path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" /><path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="4" /><path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" /><path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" /></g></svg>
                        ) : lang.code === 'es' ? (
                            <svg xmlns="http://www.w3.org/2000/svg" width="180" height="120" viewBox="0 0 20 15"><rect width="20" height="15" fill="#ff0000" /><rect width="20" height="7" fill="#ffcc00" y="5" /><rect width="20" height="7" fill="#ff0000" y="10" /></svg>
                        ) : lang.code === 'fr' ? (
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3 2" width="120" height="120"><rect width="1" height="2" x="0" y="0" fill="#0055A4"/><rect width="1" height="2" x="1" y="0" fill="#FFFFFF"/><rect width="1" height="2" x="2" y="0" fill="#EF4135"/></svg>
                        ) : lang.code === 'de' ? (
                           // deutsche svg flag like https://de.wikipedia.org/wiki/Datei:Flag_of_Germany.svg
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 3" width="180" height="120"><rect width="5" height="3" fill="#FFCE00"/><rect width="5" height="2" fill="#DD0000"/><rect width="5" height="1" fill="#000000"/></svg>
                        ) : (
                            <span className="text-primary">{lang.name}</span>
                        )}
                    </span>
                </button>
            ))}
        </div>
    );
};

export default SwitchLanguage;
